import { NumberStepperQuestionProps } from '../../types';
import { NumberStepper } from '../components/number-stepper';
import { Controller, useFormContext } from 'react-hook-form';

export const NumberStepperQuestion = ({ question }: NumberStepperQuestionProps) => {
  const { control } = useFormContext();

  const min = (question.validations?.min as number) ?? 0;
  const max = question.validations?.max as number;
  const defaultValue = question.defaultValue ?? (min > 0 ? min : 0);

  return (
    <Controller
      control={control}
      name={question.slug}
      defaultValue={defaultValue}
      render={({ field: { onChange, value } }) => {
        const handleStepperChange = (newValue: number) => {
          onChange(newValue);
        };

        return (
          <div className="questionnaire-question-content">
            <NumberStepper
              value={value ?? defaultValue}
              onChange={handleStepperChange}
              min={min}
              max={max}
              questionSlug={question.slug}
            />
          </div>
        );
      }}
    />
  );
};
